import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPCertLogicTreeLocs =
	| 'SPCertLogicTreeProvider'
	| 'SPCertLogicTreeExternalId'
	| 'SPCertLogicTreeName';

export type CPCertLogicTreeLocs =
	| 'CPCertLogicTreeProvider'
	| 'CPCertLogicTreeExternalId'
	| 'CPCertLogicTreeName';

export const spCertLogicTreeLocs: LocDefs<SPCertLogicTreeLocs> = {
	SPCertLogicTreeProvider: {
		defaultValue: 'Provider',
		description: 'Provider label',
		displayPath: 'System|Logic Tree|Provider',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'SP',
	},
	SPCertLogicTreeExternalId: {
		defaultValue: 'External ID',
		description: 'External ID label',
		displayPath: 'System|Logic Tree|External ID',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'SP',
	},
	SPCertLogicTreeName: {
		defaultValue: 'Name',
		description: 'Name label',
		displayPath: 'System|Logic Tree|Name',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'SP',
	},
};

export const cpCertLogicTreeLocs: LocDefs<CPCertLogicTreeLocs> = {
	CPCertLogicTreeProvider: {
		defaultValue: 'Provider',
		description: 'Provider label',
		displayPath: 'System|Logic Tree|Provider',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
	CPCertLogicTreeExternalId: {
		defaultValue: 'External ID',
		description: 'External ID label',
		displayPath: 'System|Logic Tree|External ID',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
	CPCertLogicTreeName: {
		defaultValue: 'Name',
		description: 'Name label',
		displayPath: 'System|Logic Tree|Name',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
};

export type CPCertLogicTreeLocKeys = LocMap<CPCertLogicTreeLocs>;
export const cpCertLogicTreeLocKeys: CPCertLogicTreeLocKeys =
	MapLocKeys<CPCertLogicTreeLocs>(cpCertLogicTreeLocs);

export type SPCertLogicTreeLocKeys = LocMap<SPCertLogicTreeLocs>;
export const spCertLogicTreeLocKeys: SPCertLogicTreeLocKeys =
	MapLocKeys<SPCertLogicTreeLocs>(spCertLogicTreeLocs);
